import { assign } from '..';
import { CreativeProps, DOMBuilder } from '../../../types';
import styles from './index.scss';

export class ImageTagBuilder {
  public static create(
    props: CreativeProps,
    domBuilder: DOMBuilder
  ): HTMLElement {
    if (props.creativeUrl) {
      ImageTagBuilder.preloadCreativeImage(props.creativeUrl);
    }

    const img = ImageTagBuilder.buildImageTag(props, domBuilder);

    return img;
  }

  private static preloadCreativeImage(creativeUrl: string | undefined): void {
    if (creativeUrl) {
      new Image().src = creativeUrl;
    }
  }

  private static buildImageTag(
    props: CreativeProps,
    domBuilder: DOMBuilder
  ): HTMLImageElement {
    const { creativeUrl, imageClassName } = props;

    const img = domBuilder.createElement<HTMLImageElement>('img');
    img.className = imageClassName ?? styles.imageCreative;
    img.src = creativeUrl;
    img.alt = 'creative';

    ImageTagBuilder.addImageStyle(img, props);

    return img;
  }

  public static addContainerStyle(
    container: HTMLDivElement,
    props: CreativeProps
  ): void {
    const policy = props.containerPolicy;

    let style: Partial<CSSStyleDeclaration> = {};

    switch (policy) {
      case 'fitHeight':
        style.height = '100%';
        style.width = container.clientHeight * props.ratio! + 'px';
        style.transform = `translate(-50%, 0)`;
        style.left = '50%';
        break;
      case 'fitWidth':
        style.width = '100%';
        style.height = container.clientWidth / props.ratio! + 'px';
        style.transform = `translate(0, -50%)`;
        style.top = '50%';
        break;
      default:
        break;
    }

    if (Object.keys(style).length === 0) return;
    assign(container.style, style);
  }

  public static addImageStyle(
    img: HTMLImageElement,
    props: CreativeProps
  ): void {
    const { imageStyle, blurEffect, backgroundColor } = props;

    let style =
      blurEffect?.show === true || backgroundColor
        ? { ...imageStyle, position: 'relative', zIndex: '1' }
        : imageStyle;

    if (style) {
      assign(img.style, style);
    }
  }
}
